import home from './views/home.vue';
import greenHouse from './views/greenHouse/house.vue';
import grow from './views/plant/grow.vue';
import news from './views/news/news.vue';
import plant from './views/classify/plant.vue';
import pests from './views/identity/pests.vue';
import controller from './views/control/pestControl.vue';
import xh from './views/answer/xinghuo.vue';
import big from './views/data/big.vue'
import qs from './views/answer/keshihua.vue'

const views = {
    home,greenHouse,grow,news,plant,pests,controller,xh,big,qs
}
const tabsTranslation = {
    "home": "首页",
    "greenHouse":"大棚管理",
    "plant":"生长识别",
    "grow":"生长监控",
    "news":"农业新闻",
    "pests":"病虫害识别",
    "controller":"防控知识",
    "xh":"智能问答",
    "big":"数据大屏",
    "qs":"灵眸可视化"
}
export { views, tabsTranslation };